import React from "react";
import styles from "./ForestBackdrop.module.css";

/* The dark surface every Art of Looking screen sits on.
   It used to also render a stripe texture, a "sun arc" radial glow, two
   concentric rings, and two corner meta strips. All of that was ornament
   layered on top of the content rather than serving it, and it is gone.
   What remains is the surface itself. */
export default function ForestBackdrop({ children }) {
  return (
    <div className={styles.shell}>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
